import _slicedToArray from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import useFocusManagerBase from '@restart/hooks/useFocusManager';
import useEventCallback from '@restart/hooks/useEventCallback';
import useMounted from '@restart/hooks/useMounted';
import matches from 'dom-helpers/matches';
var isInDisabledFieldset = function isInDisabledFieldset(node) {
  return !!node && matches(node, 'fieldset[disabled] *');
};
export default function useFocusManager(ref) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isMounted = useMounted();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocus = _useState2[1];
  var isDisabled = useEventCallback(function () {
    return props.disabled === true || isInDisabledFieldset(ref.current);
  });
  var events = useFocusManagerBase(Object.assign({}, opts, {
    isDisabled: isDisabled,
    onChange: function onChange(focused) {
      if (isMounted()) setFocus(focused);
    },
    didHandle: function didHandle(focused, event) {
      var handler = props[focused ? 'onFocus' : 'onBlur'];
      if (handler) handler(event); // @ts-ignore used by work

      if (opts.didHandle && !event.isWidgetDefaultPrevented) opts.didHandle(focused, event);
    }
  }));
  return [events, focused, setFocus];
}